export default __webpack_public_path__ + "static/media/Anarquismo.77e5bae8.pdf";